export default function() {
	if ($("html").hasClass("chrome")) {
		var $juegos = $("li.unity3d");
		$.each($juegos, function(index, val) {
			$(val)
				.find(".Games-lista-tags")
				.remove();
			$(val)
				.find("a:first")
				.prepend(
					'<div class="unity-chrome"><span>' +
						translate.chrome_alert +
						"</span> </div>"
				);
		});
	}
}
